import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
import { HEADER, NAV } from '../../config-global';
// --------------------------------------------------------------------------------------------------------

Main.propTypes = {
    sx: PropTypes.object,
    children: PropTypes.node,
};
// --------------------------------------------------------------------------------------------------------

const SPACING = 4;

export default function Main({ children, sx, ...other }) {

    const isDesktop = useResponsive('up', 'lg');
    const IsFullScreen = useSelector(state => state.screen.fullScreenVale);

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                // pt: !IsFullScreen ? `${HEADER.H_DASHBOARD_DESKTOP_NEW + SPACING}px` : '0px',
                pt: !IsFullScreen ? `${HEADER.H_DASHBOARD_DESKTOP_NEW}px` : '0px',
                ...(isDesktop && {
                    //  px: 2,
                    // pt: !IsFullScreen ? `${HEADER.H_DASHBOARD_DESKTOP_NEW + SPACING}px` : '0px',
                    pt: !IsFullScreen ? `${HEADER.H_DASHBOARD_DESKTOP_NEW}px` : '0px',
                    // width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
                    width: `100% `,
                }),
                ...sx,
            }}
            {...other}
        >
            {children}
        </Box>
    );
}
